import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  ACTION_TRACKING,
  APP_STORE_RELOAD,
  AUTH_LOGOUT,
  FAQ_GET,
  LOADER_CLOSE,
  LOADER_OPEN,
  LOGO_GET,
  SSO_PROVIDER_LIST_GET,
  SUPPORT_MAIL_GET,
  VOCABULARY_GET,
} from '../actions';
import app from '../../api/app';
import { HOME_CONFIGURATION_GET } from '../actions/home';
import { NOTIFICATION_GET } from '../actions/notifications';
import { ACTIVE_MODULES_GET } from '../actions/modules';
import { USER_INFO_GET } from '../actions/user';
import { PUBLIC_PAGE_DATA_GET } from '../actions/public';
import { getToken } from '../../api/token';

function* appReload() {
  try {
    yield put({ type: LOADER_OPEN, fullPage: true });
    const { authState: { isLogged } = {} } = yield select((state) => state.app);
    yield put({ type: LOGO_GET._REQUEST });
    yield put({ type: ACTIVE_MODULES_GET._REQUEST });
    yield put({ type: PUBLIC_PAGE_DATA_GET._REQUEST });
    yield put({ type: VOCABULARY_GET._REQUEST });
    if (isLogged) {
      yield put({ type: USER_INFO_GET._REQUEST });
      yield put({ type: HOME_CONFIGURATION_GET._REQUEST });
      yield put({ type: NOTIFICATION_GET._REQUEST });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > app > appReload', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* appReloadWatch() {
  yield takeLatest(APP_STORE_RELOAD, appReload);
}

function* faqGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { authState: { isLogged } = {} } = yield select((state) => state.app);
    const { data: { data = {} } = {} } = yield call(app.getFaq, isLogged);
    yield put({ type: FAQ_GET._SUCCESS, data });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > app > faqGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* faqGetWatch() {
  yield takeLatest(FAQ_GET._REQUEST, faqGet);
}

function* vocabularyGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: vocabulary = {} } = {} } = yield call(
      app.getVocabulary
    );

    yield put({ type: VOCABULARY_GET._SUCCESS, vocabulary });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > app > vocabularyGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* vocabularyGetWatch() {
  yield takeLatest(VOCABULARY_GET._REQUEST, vocabularyGet);
}

function* LogoGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: { logo = {} } } = {} } = yield call(app.getLogo);
    yield put({ type: LOGO_GET._SUCCESS, logo });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > app > LogoGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* LogoGetWatch() {
  yield takeLatest(LOGO_GET._REQUEST, LogoGet);
}

function* ssoProviderListGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data: response },
    } = yield call(app.ssoProviderListGet);
    yield put({ type: SSO_PROVIDER_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > app > ssoProviderListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* ssoProviderListGetWatch() {
  yield takeLatest(SSO_PROVIDER_LIST_GET._REQUEST, ssoProviderListGet);
}

function* supportMailGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data: response },
    } = yield call(app.supportMailGet);
    yield put({ type: SUPPORT_MAIL_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > app > supportMailGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* supportMailGetWatch() {
  yield takeLatest(SUPPORT_MAIL_GET._REQUEST, supportMailGet);
}

function* actionTracking({ action_type, action }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { token } = getToken();
    if (token) {
      const { data: { data: response = {} } = {} } = yield call(
        app.actionTracking,
        action_type,
        action
      );
      yield put({ type: ACTION_TRACKING._SUCCESS, response });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > app > actionTracking', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
    if (action === 'logout') yield put({ type: AUTH_LOGOUT._SUCCESS });
  }
}

function* actionTrackingWatch() {
  yield takeLatest(ACTION_TRACKING._REQUEST, actionTracking);
}

export default [
  appReloadWatch(),
  faqGetWatch(),
  vocabularyGetWatch(),
  LogoGetWatch(),
  ssoProviderListGetWatch(),
  supportMailGetWatch(),
  actionTrackingWatch(),
];
